import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExportPinOptionsModel, GroupedOptionsModel, TagGroup } from '../../models/GroupedOptionsModel';
import { Option } from '../../engine/models/models';
import { Globals } from '../../services/globals';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { OptionTag, TagFilter } from '../../models/TagFilter';
import { ExportPicturesService } from '../../services/export-pictures.service';
@Component({
  selector: 'app-grouped-options-modal',
  templateUrl: './grouped-options-modal.component.html',
  styleUrls: ['./grouped-options-modal.component.css']
})

export class GroupedOptionsModalComponent {
  optionsModel: GroupedOptionsModel
  comparisionModel: Option[] = [];
  zoomLevel = 100;
  time = 0; //seconds
  exporting = false;
  recursion = false;
  dict = {};
  comparisonMode = false;
  maxComparisons = 3;

  // Adding this temp code back because the other code does not work without making a tag a group (which is not correct)
  setTempDict() {
    // Should come from database
    this.dict['PIN KITCHEN'] = 'Kitchen';
    this.dict['PIN OWNERS BATH'] = 'Owner\'s Bath';
    this.dict['PIN BATH 2'] = 'Bath 2';
    this.dict['PIN BATH 3'] = 'Bath 3';
    this.dict['PIN BATH 4'] = 'Bath 4';
    this.dict['PIN BATH 5'] = 'Bath 5';
    this.dict['PIN BATH 6'] = 'Bath 6';
    this.dict['PIN BATH 7'] = 'Bath 7';
    this.dict['PIN POWDER'] = 'Powder Room';
  }

  constructor(private dialogRef: MatDialogRef<GroupedOptionsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: GroupedOptionsModel,
    public global: Globals, private router: Router,
    private loader: NgxUiLoaderService,
    private toastr: ToastrService,
    private exportService: ExportPicturesService
  ) {
    // This needs to come from the database.  Only for demo.
    this.setTempDict();
    // Only show groups that have valid options
    let groups: TagGroup[] = [];
    let options: Option[] = [];
    for (let option of this.data.options.filter(q => q.selectedOption)) {
      let tag = option.tags.filter(q => q.startsWith("PIN"))[0];
      if (tag !== undefined) {
        if (!option.defaultGalleryPictureMissing) {
          options.push(option);
          if (!groups.some(x => x.tagName == tag)) {
            let tagGroup: TagGroup = {
              tagName: tag,
              tagDisplayName: tag,
              displayOrder: 0
            };

            switch (tag) {
              case 'PIN KITCHEN':
                tagGroup.displayOrder = 1;
                break;
              case 'PIN OWNERS BATH':
                tagGroup.displayOrder = 2;
                break;
              case 'PIN BATH 2':
                tagGroup.displayOrder = 3;
                break;
              case 'PIN BATH 3':
                tagGroup.displayOrder = 4;
                break;
              case 'PIN BATH 4':
                tagGroup.displayOrder = 5;
                break;
              case 'PIN BATH 5':
                tagGroup.displayOrder = 6;
                break;
              case 'PIN BATH 6':
                tagGroup.displayOrder = 7;
                break;
              case 'PIN BATH 7':
                tagGroup.displayOrder = 8;
                break;
              case 'PIN POWDER':
                tagGroup.displayOrder = 9;
                break;
            }

            groups.push(tagGroup);
          }
        }
      }
    }
    data.options = options;
    data.groups = groups.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1);

    this.optionsModel = data;
  }

  filterByValue(array: Option[], value: TagGroup): Option[] {
    let group = array.filter(q => q.tags.includes(value.tagName));
    return group;
  }

  formattedOptionPicture(option: Option): string {
    return option.defaultGalleryPicture;
  }

  get getUrlWithoutParams(): string {
    return this.router.url.split('?')[0];
  }

  showZoomLevel() {
    this.time = 3;
    if (!this.recursion) {
      this.recursion = true;
      this.recursive();
    }
  }

  recursive() {
    if (this.time > 0) { this.time -= 1; }
    else { this.recursion = false; }
    setTimeout(() => { this.recursive() }, 1000);
  }

  zoomIn() {
    if (this.zoomLevel < 180) {
      this.zoomLevel += 5;
    }
    this.showZoomLevel()
  }

  zoomOut() {
    if (this.zoomLevel > 20) {
      this.zoomLevel -= 5;
    }
    this.showZoomLevel()
  }

  download() {
    this.exporting = true;
    let data = this.getExportData()
    this.exportService.exportPinOptions(data).subscribe(result => {
      const linkSource = 'data:application/pdf;base64,' + result.data;
      const downloadLink = document.createElement("a");
      downloadLink.href = linkSource;
      downloadLink.download = result.fileName;
      downloadLink.click();
      this.exporting = false;
    }, error => {
      this.toastr.error("An unknown error occurred.", "Error")
      this.exporting = false;
    });
  }

  getExportData(): ExportPinOptionsModel[] {
    let exportPinOptionsModel: ExportPinOptionsModel[] = [];
    for (let group of this.optionsModel.groups) {
      let exportModel: ExportPinOptionsModel = new ExportPinOptionsModel();
      exportModel.title = this.dict[group.tagName];
      exportModel.displayOrder = group.displayOrder;
      exportModel.options = [];
      let options = this.filterByValue(this.optionsModel.options, group)
      for (let option of options) {
        exportModel.options.push(
          {
            optionId: option.optionId,
            description: option.selectedOption.description,
            url: option.selectedOption.defaultGalleryPicture
          })
      }
      exportPinOptionsModel.push(exportModel);
    }
    return exportPinOptionsModel;
  }

  optionsToCompare: Option[] = [];
  saveForCompare(option: Option) {
    var existingOption = this.optionsToCompare.findIndex(q => q.optionId === option.optionId);
    if (existingOption >= 0) {
      this.optionsToCompare.splice(existingOption, 1);
      option.isCompareChecked = false;
    } else {
      this.optionsToCompare.push(option);
      option.isCompareChecked = true;
    }
  }

  galleryImages(option: Option): string[] {
    let _gallery: string[] = [];
    if (option.selectedPictureGallery?.length === 1 && !option.selectedPictureGallery[0]) {
      option.selectedPictureGallery = [];
    }

    let uniquePictures = Array.from(new Set(option.selectedPictureGallery)).filter(q => q != "undefined" && q != null);

    if (option.selectedPictureGallery &&
      _gallery.sort() !== uniquePictures.sort()) {

      _gallery = [];

      for (let image of uniquePictures) {
        if (!image) {
          continue;
        }
        if (image && !image.includes("/assets/images")) {
          if (!image.includes("http")) {
            image = this.global.engine.formatPictureUrl(image);
          }

          // Don't add the same image twice (for multiple style scenarios)
          _gallery.push(image);
        }
      }

      // Show custom photos from Media Associations
      if (this.global?.mediaAssociations?.length && option?.selectedOption) {
        const matches = this.global.mediaAssociations.filter(q => q.optionId === option.selectedOption.optionId);

        if (matches?.length) {
          for (const match of matches) {
            _gallery.push(match.contentUrl);
          }
        }
      }
    }
    return _gallery;
  }

  loadError(img: any) {
    img.target.parentNode.classList.add('dis-none');
  }

  getHeight(imgCount: number) {
    imgCount = imgCount > 2 ? 2 : imgCount;
    let height = this.getZoomArray.find(x => x.point == this.zoomLevel).height
    return (height / imgCount);
  }

  get getZoomArray(): any[] {
    let zoomArray: { point: number, height: number }[] = [
      { point: 180, height: 460 },
      { point: 175, height: 450 },
      { point: 170, height: 440 },
      { point: 165, height: 430 },
      { point: 160, height: 420 },
      { point: 155, height: 410 },
      { point: 150, height: 400 },
      { point: 145, height: 390 },
      { point: 140, height: 380 },
      { point: 135, height: 370 },
      { point: 130, height: 360 },
      { point: 125, height: 350 },
      { point: 120, height: 340 },
      { point: 115, height: 330 },
      { point: 110, height: 320 },
      { point: 105, height: 310 },
      { point: 100, height: 300 },
      { point: 95, height: 290 },
      { point: 90, height: 280 },
      { point: 85, height: 270 },
      { point: 80, height: 260 },
      { point: 75, height: 250 },
      { point: 70, height: 240 },
      { point: 65, height: 230 },
      { point: 60, height: 220 },
      { point: 55, height: 210 },
      { point: 50, height: 200 },
      { point: 45, height: 190 },
      { point: 40, height: 180 },
      { point: 35, height: 170 },
      { point: 30, height: 160 },
      { point: 25, height: 150 },
      { point: 20, height: 140 }
    ];
    return zoomArray;
  }
}
